<div class="flex flex-col justify-center text-center align-middle screen">
  <img class="h-40" src="assets/images/elsi-logo.svg" alt="Elsi-Logo" />
</div>
